import { render, staticRenderFns } from "./AddContractorRegion.vue?vue&type=template&id=2c31a985"
import script from "./AddContractorRegion.vue?vue&type=script&lang=js"
export * from "./AddContractorRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports